import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import styles from './RaceDate.module.scss';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
const RaceDate = ({ elem, borderRight, className }) => {
    const { t } = useTranslation();
    return (_jsx("div", Object.assign({ className: cn(styles.element, className) }, { children: Object.keys(elem).map((key) => (_jsxs("div", Object.assign({ className: cn(styles.list, 'd-flex flex-column', borderRight && styles['isBorderRight']) }, { children: [_jsx("div", { children: t(key) }), _jsx("div", Object.assign({ className: styles.desc }, { children: elem[key] }))] }), key))) })));
};
export default RaceDate;
